import { css, CSSResult } from 'lit'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const cseButtonInput = {
  backgroundColor: css`var(--cse-button-input-background-color, ${csFormControl.backgroundColor})`,
  backgroundColorDisabled: css`var(--cse-button-input-background-color-disabled, ${csFormControl.backgroundColorDisabled})`,
  borderWidth: css`var(--cse-button-input-border-width, ${csFormControl.borderWidth})`,
  borderColor: css`var(--cse-button-input-border-color, ${csFormControl.borderColor})`,
  borderColorError: css`var(--cse-button-input-border-color-error, ${csFormControl.borderColorError})`,
  borderColorSuccess: css`var(--cse-button-input-border-color-success, ${csFormControl.borderColorSuccess})`,
  borderRadius: css`var(--cse-button-input-border-radius, ${csFormControl.borderRadius})`,
  color: css`var(--cse-button-input-color, ${csFormControl.color})`,
  colorDisabled: css`var(--cse-button-input-color-disabled, ${csFormControl.colorDisabled})`,
  fontSize: css`var(--cse-button-input-font-size, ${csFormControl.fontSize})`,
  fontFamily: css`var(--cse-button-input-font-family, ${csFormControl.fontFamily})`,
  lineHeight: css`var(--cse-button-input-line-height, normal)`,
  textTransform: css`var(--cse-button-input-text-transform, none)`,
  gap: css`var(--cse-button-input-gap, ${csSpacing.spacing05})`,
  height: css`var(--cse-button-input-height, auto)`,
  paddingLeft: css`var(--cse-button-input-padding-left, ${csFormControl.paddingInline})`,
  paddingRight: css`var(--cse-button-input-padding-right, ${csSpacing.spacing02})`,
  paddingBlock: css`var(--cse-button-input-padding-y, ${csSpacing.spacing02})`,

  outlineFocus: css`var(--cse-button-input-outline-focus, ${csFormControl.outlineFocus})`,
  placeholderColor: css`var(--cse-button-input-placeholder-color, ${csFormControl.placeholderColor})`,
  actionsGap: css`var(--cse-button-input-actions-gap, ${csSpacing.spacing05})`,
}

export const style: CSSResult = css`
  .cse-button-input {
    align-items: center;
    background: ${cseButtonInput.backgroundColor};
    border-color: ${cseButtonInput.borderColor};
    border-style: solid;
    border-radius: ${cseButtonInput.borderRadius};
    border-width: ${cseButtonInput.borderWidth};
    color: ${cseButtonInput.color};
    display: flex;
    font-size: ${cseButtonInput.fontSize};
    font-family: ${cseButtonInput.fontFamily};
    line-height: ${cseButtonInput.lineHeight};
    text-transform: ${cseButtonInput.textTransform};
    gap: ${cseButtonInput.gap};
    height: ${cseButtonInput.height};
    padding-block: ${cseButtonInput.paddingBlock};
    padding-right: ${cseButtonInput.paddingRight};
    padding-left: ${cseButtonInput.paddingLeft};
    transition-duration: ${csTransition.duration};
    transition-timing-function: ${csTransition.timingFunction};
    transition-property: color, background-color, border-color;
    width: 100%;
  }

  .cse-button-input.disabled {
    background-color: ${cseButtonInput.backgroundColorDisabled};
    color: ${cseButtonInput.colorDisabled};
  }

  .cse-button-input:has(input:focus-visible) {
    outline: ${cseButtonInput.outlineFocus};
  }

  input {
    all: unset;
    align-self: stretch;
    flex: 1;
  }

  input::placeholder {
    color: ${cseButtonInput.placeholderColor};
    opacity: 1;
  }

  .cse-button-input.valid-error {
    border-color: ${cseButtonInput.borderColorError};
  }

  .cse-button-input.valid-success {
    border-color: ${cseButtonInput.borderColorSuccess};
  }

  .actions {
    display: flex;
    align-items: center;
    gap: ${cseButtonInput.actionsGap};
  }
`
